import axios from 'axios';
export var ResetPassword = function (baseURL, params) {
    return axios.put(baseURL + '/reset/reset-password', {
        email: params.email,
        confirm_password: params.confirm_password,
        password: params.password,
        token: params.token,
    }, {
        headers: { 'Content-Type': 'application/json' },
    });
};
